import React, { useState, useEffect } from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import CauHinhApi from "service/cauHinhApi";

const QuyTienMatSearch = ({
  dataSearch,
  onChangeDate,
  onSearch,
  handleChange,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const [isQuanLyMuaBan, setIsQuanLyMuaBan] = useState(false);
  useEffect(() => {
    if (isLoading) {
      CauHinhApi.getConfigSys1().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const cauHinhMuaBan = response.data.find(
              (e) => e.keyConfig.toUpperCase() === "ISQUANLYMUABAN"
            );
            if (cauHinhMuaBan) {
              if (cauHinhMuaBan.valueConfig == "1") setIsQuanLyMuaBan(true);
            }
          }
        }
      });
      setIsLoading(false);
    }
  }, []);

  return (
    <div
      className="card border-light show-table-main card-v2"
      style={{ marginTop: "-8px" }}
    >
      <div className="card-body card-body-v2">
        <div
          className="search-new"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "15px",
            alignItems: "flex-end",
          }}
        >
          <div className="input-sm-new input-new-18 flex-wrap">
            <label htmlFor="DateFrom" className="font-color-default font-bold">
              Từ ngày
            </label>
            <DateTimePicker
              id="DateFrom"
              value={dataSearch.DateFrom}
              onChange={onChangeDate("DateFrom")}
              placeholder="Từ ngày"
              name="DateFrom"
            />
          </div>

          <div className="input-sm-new input-new-18 flex-wrap">
            <label htmlFor="DateTo" className="font-color-default font-bold">
              Đến ngày
            </label>
            <DateTimePicker
              id="DateTo"
              value={dataSearch.DateTo}
              onChange={onChangeDate("DateTo")}
              placeholder="Đến ngày"
              name="DateTo"
            />
          </div>
          {isQuanLyMuaBan && (
            <div className="input-sm-new input-new-18 flex-wrap">
              <label htmlFor="DateTo" className="font-color-default font-bold">
                Hình thức thanh toán
              </label>
              <select
                name="BeforeAfter"
                className="form-control input-sm select-v2"
                onChange={handleChange("hinhThucThanhToan")}
                value={dataSearch.hinhThucThanhToan}
              >
                <option value="-1">Tất cả</option>
                <option value="0">Tiền mặt</option>
                <option value="1">Chuyển khoản</option>
              </select>
            </div>
          )}

          <div className="input-sm-new search-main-new">
            <button
              type="button"
              className="btn btn-info-new"
              style={{ padding: "7px 15px", marginBottom: 1 }}
              onClick={onSearch}
            >
              <i className="la la-search"></i>
              <span> &nbsp; Tìm kiếm</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuyTienMatSearch;
